import React, { useState } from "react";
import "./sellwithus.css";

const SellWithUs = () => {
  const [activeTab, setActiveTab] = useState("contact");

  const tabs = [
    { id: "contact", label: "Get Started" },
    { id: "Expertise", label: "Expertise" },
    { id: "Visibility", label: "Visibility" },
    { id: "transparency", label: "Transparency" },
    { id: "Network", label: "Our Network" },
   
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "Expertise":
        return (
          <>
            <h3>Why Sell With Us?</h3>
            <p>
              We know your local market inside and out — so your property is priced to sell, not sit.
            </p>
          </>
        );
      case "Visibility":
        return (
          <>
           
           <p>Your listing gets maximum exposure with high-impact marketing and pro photography.</p>
          </>
        );
      case "transparency":
        return (
          <>
            <p>
            No surprises. Just a smooth, guided process with full communication at every step.
            </p>
          </>
        );
      case "Network":
        return (
          <>
            <h3>Our Nationwide Network</h3>
            <p>
               Tap into our database of ready, qualified buyers actively searching right now.
            </p>
          </>
        );
      case "contact":
        return (
          <>
            <h3>Ready to Sell Your Property?</h3>
            <p>
              Selling real estate is more than just listing — it’s about
              reaching the right buyers, at the right time, with the right
              strategy.
            </p>
            <p>
              At <b>EAEKANEM CONSULTING</b>, we make selling your home or
              investment property simple, fast, and profitable.
            </p>
<a className="sell-btn" href="https://eaekanemconsulting.fillout.com/t/uSCnena5omus">Start Selling</a>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <section className="sell-section">
      <h1 className="sell-title">Sell With Us</h1>
      <p className="sell-intro">
        Choosing to let us assist you with the sale of your property means that
        we walk with you at every stage of your transaction journey. With
        innovative technology and unrivalled service, we ensure your property is
        connected with buyers locally and worldwide.
      </p>
      <h3 className="sel-title">Ready to Sell Your Property?</h3>
       <p className="sell-intro">
        Selling real estate is more than just listing a property — it’s about reaching the right buyers, at the right time, with the right strategy. At EAEKANEM CONSULTING, we make selling your home or investment property simple, fast, and profitable.
      </p>

      <div className="tabs-container">
        <div className="tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-btn ${
                activeTab === tab.id ? "active" : ""
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="tab-content">
          {renderContent()}
        </div>
      </div>
    </section>
  );
};

export default SellWithUs;
